// Centralized business data - single source of truth
// Each business can belong to multiple categories

import tgs from "../../src/assets/TGSsPA.jpg";
import karmora_spa from "../../src/assets/karmora_spa.png";
import Zaitoon_spa from "../../src/assets/zaitoon_spa.jpg";
import timespire from "../../src/assets/timesaspire.png";
import libra_events from "../../src/assets/libra.png";
import kbpatel_events from "../../src/assets/k B Patel.jpg";   
import PG from "../../src/assets/nobroragePgh.jpeg";


import playful_panda from "../../src/assets/PLAYFULL-PANDA.png";
import red_school from "../../src/assets/red_school.png";
import cafe_honeyman from "../../src/assets/cafe_honeyman.jpg";
import shivsai_villa from "../../src/assets/shivsai_villa.jpg";
import aircool_ac from "../../src/assets/aircool_ac.png";
import jayambe_ac from "../../src/assets/jayambe_ac.webp";
import proactive_physio from "../../src/assets/proactive_physio.png";
import rudra_physio from "../../src/assets/Rudra.jpg";
import divine_astro from "../../src/main/dashboard/assets/divine_astro.jpg";
import eva from "../../src/main/dashboard/assets/Eva Banquet.jpg";
import IndiaAutoCenter from "../../src/main/dashboard/assets/india_auto_centre.webp";
import rajorii from "../../src/main/dashboard/assets/rajori.jpg";
import ReadyToGo from "../../src/main/dashboard/assets/ReadyToGo.webp";
import smp from "../../src/main/dashboard/assets/smp.png";
export const BUSINESS_DATA = [
  // Beauty Spa
  {
    id: 'tgs-001',
    name: 'TGS Spa',
    categories: ['beauty-spa','spa-massage'],
    rating: 4.8,
    reviews: 16,
    phone: '+91 9909406666',
    email: 'info.tgsspa@gmail.com',
    address: '204, Midtown Heights, Jetalpur Road, Alkapuri, Vadodara, Gujarat 390007',
    description: 'Premium beauty spa offering facials, massages, and wellness treatments with expert therapists.',
    image: tgs,
    priceRange: '$$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'tgsspa.com/',
    hours: '9:00 AM - 8:00 PM',
    features: ['AC', 'Parking', 'Female Staff', 'Steam Room'],
    verified: true,
    featured: true
  },
  {
    id: 'karmora-002',
    name: 'Karmora Wellness',
    categories: ['beauty-spa','spa-massage'],
    rating: 4.3,
    reviews: 65,
    phone: '+91 8108682205',
    email: 'Karmoraspa.com@gmail.com',
    address: 'F4, 3rd Floor, Shantam Greens Commercial Complex, Vasna Rd, near Raneshwar Mandir, opp. Axis Bank, Vadodara, Gujarat 390012',
    description: 'Holistic wellness center specializing in Ayurvedic treatments and modern spa therapies.',
    image: karmora_spa,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'karmora-spa.com/',
    hours: '09:00 AM - 07:00 PM',
    features: ['AC', 'Parking', 'Ayurvedic', 'Yoga'],
    verified: true,
    featured: false
  },
  {
    id: 'zaitoon-003',
    name: 'Zaitoon Beauty Center',
    categories: ['beauty-spa','spa-massage'],
    rating: 5.0,
    reviews: 3,
    phone: '+91 7718837955',
    email: 'zaitoonspa2024@gmail.com',
    address: 'Sharnam Fortune, F - 6 & 7, opposite Inox Multiplex, Race Course, Vadiwadi, Vadodara, Gujarat 390007',
    description: 'Complete beauty solutions including hair, makeup, and skincare treatments.',
    image: Zaitoon_spa,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'zaitoonspa.com/',
    hours: '9:00 AM - 9:00 PM',
    features: ['AC', 'Parking', 'Hair Studio', 'Makeup'],
    verified: false,
    featured: false
  },

  // Events
  {
    id: 'timespire-004',
    name: 'Timespire Events',
    categories: ['events','event-organisers'], // Changed from event-organisers to events
    rating: 4.8,
    reviews: 234,
    phone: '+91 9322984151',
    email: 'Support@timesaspire.com',
    address: '2052, Delta wood village, Mira MIDC road Mahajan Wadi, Mira Road (East) Mumbai City, District: Thane 401107',
    description: 'Professional event planning company for corporate events, weddings, and parties.',
    image: timespire,
    priceRange: '$$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'www.timesaspire.com/',
    hours: '10:00 AM - 7:00 PM',
    features: ['Event Planning', 'Confrence', 'Summit', 'Events'],
    verified: true,
    featured: true
  },
  {
    id: 'libra-005',
    name: 'Libra Events & Weddings',
    categories: ['events', 'wedding-planning','banquet-halls'], // Changed from event-organisers to events
    rating: 4.6,
    reviews: 189,
    phone: '+91 9909254684',
    email: 'libraeventsdecorators@gmail.com',
    address: 'Basement, 2, Eva Mall Rd,near Saraswati Complex,Patidar Crossing, Manjalpur, Vadodara, Gujarat 390011',
    description: 'Complete wedding and event planning services with experienced team.',
    image: libra_events,
    priceRange: '$$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'www.libraeventsanddecorators.com/',
    hours: '11:00 AM – 07:00 PM',
    features: ['Wedding Planning', 'Photography', 'Catering', 'Decoration'],
    verified: true,
    featured: false
  },
  {
    id: 'kbpatel-006',
    name: 'K B Patel Events',
    categories: ['events','wedding-planning','banquet-halls'], // Changed from event-organisers to events
    rating: 4.1,
    reviews: 460,
    phone: '+91 9825077188',
    email: 'libraeventsdecorators@gmail.com',
    address: 'Manjalpur, Vadodara, Gujarat 39001',
    description: 'Budget-friendly event management for all occasions and celebrations.',
    image: kbpatel_events,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'www.libraeventsanddecorators.com/',
    hours: '10:00 AM - 6:00 PM',
    features: ['Event Management', 'Budget Planning', 'Small Events'],
    verified: false,
    featured: false
  },

  // Rent & Hire
  {
    id: 'nobroke-007',
    name: 'No Broke PG',
    categories: ['rent-hire', 'pg-hostels'],
    rating: 5.0,
    reviews: 3,
    phone: '+91 8879779777',
    email: 'swetarita25786@gmail.com',
    address: 'Pandit Soliciter Road,Opposite Blue Diamond, Malad East Mumbai - 400097',
    description: 'Affordable paying guest accommodation with modern amenities.',
    image: PG,
    priceRange: '$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'nobrokeragepayingguest.in/',
    hours: '24/7',
    features: ['WiFi', 'AC', 'Laundry', 'Security'],
    verified: true,
    featured: false
  },

  // Education
  {
    id: 'playful-008',
    name: 'Playful Panda',
    categories: ['education'],
    rating: 4.9,
    reviews: 3,
    phone: '+91 8866455766',
    email: 'info@playfulpanda.co.in',
    address: 'B-10, Jay Gayetri Nagar Society, V.I.P Road,Karelibaug, Vadodara, Gujarat - 390018',
    description: 'Premium preschool and daycare with modern learning facilities.',
   image: playful_panda,
    priceRange: '$$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'playfulpanda.co.in/',
    hours: '8:00 AM - 6:00 PM',
    features: ['Playground', 'AC', 'Security', 'Transport'],
    verified: true,
    featured: true
  },
  {
    id: 'redschool-009',
    name: 'Red School',
    categories: ['education'],
    rating: 5.0,
    reviews: 5,
    phone: '+91 7778851070',
    email: 'redschoolhousebaroda@gmail.com',
    address: 'A-25, Castle white, Opposite main Harni Water Tank, Harni Sama Link Road, Vadodara.',
    description: 'Quality primary and secondary education with experienced faculty.',
    image: red_school ,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'www.redhouseschoolvadodara.in/',
    hours: '8:00 AM - 3:00 PM',
    features: ['Library', 'Sports', 'Science Lab', 'Computer Lab'],
    verified: true,
    featured: false
  },

  // Restaurant
  {
    id: 'cafehoney-010',
    name: 'Cafe Honeyman',
    categories: ['restaurants'],
    rating: 4.5,
    reviews: 23,
    phone: '+91 9173911334',
    email: 'cafehoneymanexpress@gmail.com',
    address: 'E4, Kashi Vishweshwar Township,Jetalpur Road, Alkapuri,Vadodara',
    description: 'Cozy cafe serving artisanal coffee, fresh pastries, and light meals.',
    image: cafe_honeyman,
    priceRange: '$$',
    delivery: true,
    takeaway: true,
    reservation: true,
    website: 'www.cafehoneymanexpressvadodara.in/',
    hours: '10:00 AM - 10:00 PM',
    features: ['AC', 'WiFi', 'Outdoor Seating', 'Pet Friendly'],
    verified: true,
    featured: true
  },

  // Wedding Planning
 

  // Villa
  {
    id: 'shivsai-012',
    name: 'Shiv Sai Holiday Homes',
    categories: ['villa'], // Changed from popular to villa
    rating: 5.0,
    reviews: 9,
    phone: '+91 98229 39767',
    email: 'info@shivsaiholidayhome.com',
    address: 'At Revas Road, Post, near Shankar Temple, Chondhi, Agarsure, Maharashtra 402208',
    description: 'Luxury villa rentals for holidays and weekend getaways.',
    image: shivsai_villa ,
    priceRange: '$$$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'shivsaiholidayhome.com/',
    hours: '24/7',
    features: ['Swimming Pool', 'Garden', 'Kitchen', 'AC'],
    verified: true,
    featured: false
  },

  // AC Service
  {
    id: 'aircool-013',
    name: 'Air Cool AC Service',
    categories: ['ac-service'], // Changed from popular to ac-service
    rating: 5.0,
    reviews: 3,
    phone: '+91 9819095994',
    email: 'aircoolmumbai2025@gmail.com',
    address: 'AA-10, B.M.C. Colony, Anand Nagar Near Heera Panna Mall, Oshiwara, Jogeshwari (W), Mumbai - 400 102',
    description: 'Professional AC installation, repair, and maintenance services.',
    image: aircool_ac ,
    priceRange: '$$',
    delivery: true,
    takeaway: false,
    reservation: true,
    website: 'aircoolmumbai.com/',
    hours: '8:00 AM - 8:00 PM',
    features: ['24/7 Service', 'Installation', 'Repair', 'AC'],
    verified: true,
    featured: false
  },
  {
    id: 'jayambe-014',
    name: 'Jay AMBE AC Service',
    categories: ['ac-service'], // Changed from popular to ac-service
    rating: 4.2,
    reviews: 76,
    phone: '+91 9876543223',
    email: 'contact@jayambe.com',
    address: '888 Cooling Street, Bangalore',
    description: 'Reliable AC service provider with experienced technicians.',
    image: jayambe_ac ,
    priceRange: '$',
    delivery: true,
    takeaway: false,
    reservation: true,
    website: 'www.jayambe.com',
    hours: '7:00 AM - 10:00 PM',
    features: ['Repair', 'Installation', 'Gas Filling', 'Maintenance'],
    verified: false,
    featured: false
  },

  // Physiotherapy
  {
    id: 'proactive-015',
    name: 'Proactive Physiotherapy',
    categories: ['physiotherapy'], // Changed from popular to physiotherapy
    rating: 4.8,
    reviews: 23,
    phone: '+91 9974167672',
    email: 'proactive@info.com',
    address: '999 Health Center, Bangalore',
    description: 'Advanced physiotherapy treatments with modern equipment.',
     image: proactive_physio,
    priceRange: '$$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'proactivephysiocare.in/',
    hours: '10:00 AM - 6:00 PM',
    features: ['Modern Equipment', 'Male/Female Staff', 'Parking', 'AC'],
    verified: true,
    featured: true
  },
  {
    id: 'rudra-016',
    name: 'Rudra Physiotherapy',
    categories: ['physiotherapy'], // Changed from popular to physiotherapy
    rating: 5.0,
    reviews: 8,
    phone: '+91 9876543225',
    email: 'www.instagram.com/rudraphysiotherapy15/',
    address: 'FF-20, Vrundavanpark, Ajwa Rd, near Siddheshwar hallmark, Kamla Nagar, Madhavpura, Vadodara, Gujarat 390019',
    description: 'Specialized physiotherapy for sports injuries and rehabilitation.',
    image: rudra_physio ,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'www.instagram.com/rudraphysiotherapy15/?__pwa=1#',
    hours: '9:00 AM - 7:00 PM',
    features: ['Sports Therapy', 'Physiotherapy','Rehabilitation', 'Exercise Area'],
    verified: false,
    featured: false
  },


  {
    id: 'divina-017',
    name: 'Divine Astro & Vastu Consultant',
    categories: ['Astrology'], // Changed from popular to physiotherapy
    rating: 4.9,
    reviews: 78,
    phone: '+91 9825567426',
    email: 'www.instagram.com/rudraphysiotherapy15/',
    address: 'Char Rasta, water Tank, 44 , Natraj nagar Kaladarshan, Waghodia Rd, near Nalanda, Vadodara, Gujarat 390019',
    description: 'At Divine Astro & Vastu Consultant, we guide individuals and businesses toward harmony, prosperity, and spiritual well-being through the timeless sciences of Astrology, Vastu, and Karma Kand. With years of experience and deep-rooted knowledge, we blend tradition with practical wisdom to help you overcome challenges and invite positivity into every aspect of life',
    image: divine_astro ,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'https://divineastrovastuconsultan.bytecard.in/',
    hours: '9:00 AM - 7:00 PM',
    features: ['Astrology', 'Vastu Pujan','Navchandi', 'Exercise Area'],
    verified: true,
    featured: false
  },
  {
    id: 'Eva-018',
    name: 'Eva Banquet',
    categories: ['events', 'wedding-planning','banquet-halls'], // Changed from event-organisers to events
    rating: 4.6,
    reviews: 273,
    phone: '+91 9825077188',
    email: 'libraeventsdecorators@gmail.com',
    address: 'Basement 1, Eva Mall Road, Patidar Crossing, near Saraswati Complex, Manjalpur, Vadodara, Gujarat 390011',
    description: 'Complete wedding and event planning services with experienced team.',
    image: eva,
    priceRange: '$$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'www.libraeventsanddecorators.com/Evabanquet',
    hours: '11:00 AM – 07:00 PM',
    features: ['Wedding Planning', 'Photography', 'Catering', 'Decoration'],
    verified: true,
    featured: false
  },
{
    id: 'auto-019',
    name: 'India Auto Centre',
    categories: ['repair-services'], 
    rating: 4.5,
    reviews: 4,
    phone: '+91 9819095994',
    email: 'https://www.facebook.com/indiaautocenter/',
    address: 'Madhumilan Shopping Center, 6-7/A, High Tension Rd, Subhanpura, Vadodara, Gujarat 390021',
    description: ' We care for your vehicle; To Keep your life running.',
    image: IndiaAutoCenter ,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'https://www.facebook.com/indiaautocenter/',
    hours: '8:00 AM - 8:00 PM',
    features: ['24/7 Service','Repair', 'Auto Service',],
    verified: true,
    featured: false
  },
  {
    id: 'RAJORII - 020',
    name: 'RAJORII POSHAKS & SAREES',
    categories: ['saree'], // Changed from popular to physiotherapy
    rating: 4.9,
    reviews: 78,
    phone: '+91 8140000126',
    email: 'https://www.facebook.com/people/Rajorii-POSHAKSSAREES/61584345300666/',
    address: 'first glass company, Shreeji Darshan Complex, 237/2, Vaikunth Society 1, Kendranagar, Vadodara, Gujarat 390019',
    description: 'RAJORII Poshaks & Sarees, Inspired by the grandeur of Rajasthan’s royal heritage, RAJORII creates Rajputana poshaks and sarees that blend traditional grace with everyday affordability. Our designs honour timeless craftsmanship while ensuring that every woman can experience royal elegance without compromise. At RAJORII, we believe luxury should be within reach, and our ensembles reflect that promise through thoughtful detailing, quality fabrics, and accessible pricing',
    image: rajorii ,
    priceRange: '$$',
    delivery: true,
    takeaway: false,
    reservation: true,
    website: 'https://www.facebook.com/people/Rajorii-POSHAKSSAREES/61584345300666/',
    hours: '9:00 AM - 7:00 PM',
    features: ['saree','poshak'],
    verified: true,
    featured: false
  },
   {
    id: 'ReadyToGo - 021',
    name: 'Ready To Go Service Center',
    categories: ['repair-services','bike-service'], // Changed from popular to physiotherapy
    rating: 4.8,
    reviews: 26,
    phone: '+91 9925934954',
    email: 'https://www.facebook.com/people/Ready-To-Go-Service-Center/61584445857798/',
    address: 'GF - 09, Kasper Square, near Jivan Jyot Hospital, Anmol Park Society, Laxmipura, Gotri, Vadodara, Gujarat 390021',
    description: 'Ready To Go Service Center is your premier destination for two-wheeler repair and maintenance in Vadodara. Located conveniently at GF-09 Kasper Square, near Jivan Jyot Hospital in the Laxmipura Gotri area, this trusted center provides expert care for your ride. Their skilled technicians are dedicated to ensuring your scooter or motorcycle is in top condition, offering reliable services to keep you on the road safely. Experience professional service and meticulous attention to detail at a facility committed to keeping your two-wheeler running smoothly.',
    image: ReadyToGo ,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'https://www.facebook.com/people/Ready-To-Go-Service-Center/61584445857798/',
    hours: '9:00 AM - 7:00 PM',
    features: ['service','bike service','repair service'],
    verified: true,
    featured: false
  },
  {
    id: 'smp - 021',
    name: 'SMP PLACEMENTS',
    categories: ['education'], // Changed from popular to physiotherapy
    rating: 4.8,
    reviews: 26,
    phone: '+91 9662666788',
    email: ' info@smpplacements.com',
    address: 'B/10, Jay Gayetri Nagar Society, V.I.P Road, Karelibaug, Vadodara, Gujarat-390018',
    description: 'SMP Placements is a trusted recruitment and training platform in India, helping companies hire skilled candidates and helping students build successful careers. With a focus on quality hiring, job-ready training, internships, and career development, we aim to create a smooth connection between employers and talented job seekers.',
    image: smp ,
    priceRange: '$$',
    delivery: false,
    takeaway: false,
    reservation: true,
    website: 'https://www.smpplacements.com/',
    hours: '9:00 AM - 7:00 PM',
    features: ['Study Abroad','Placement Services','Internship Programs','Technical Courses & Skill Development','Corporate Hiring & Recruitment Solutions'],
    verified: true,
    featured: false
  },
  // {
  //   id: 'B2B-017',
  //   name: 'B2B',
  //   categories: ['physiotherapy'], // Changed from popular to physiotherapy
  //   rating: 5.0,
  //   reviews: 8,
  //   phone: '+91 9876543225',
  //   email: 'www.instagram.com/rudraphysiotherapy15/',
  //   address: 'FF-20, Vrundavanpark, Ajwa Rd, near Siddheshwar hallmark, Kamla Nagar, Madhavpura, Vadodara, Gujarat 390019',
  //   description: 'Specialized physiotherapy for sports injuries and rehabilitation.',
  //   image: rudra_physio ,
  //   priceRange: '$$',
  //   delivery: false,
  //   takeaway: false,
  //   reservation: true,
  //   website: 'www.instagram.com/rudraphysiotherapy15/?__pwa=1#',
  //   hours: '9:00 AM - 7:00 PM',
  //   features: ['Sports Therapy', 'Physiotherapy','Rehabilitation', 'Exercise Area'],
  //   verified: false,
  //   featured: false
  // },
];

// Helper function to get businesses by category
export const getBusinessesByCategory = (categorySlug) => {
  if (!categorySlug) return [];
  
  return BUSINESS_DATA.filter(business => 
    business.categories.includes(categorySlug)
  );
};

// Helper function to get all categories that have businesses
export const getCategoriesWithBusinesses = () => {
  const categoryMap = {};
  
  BUSINESS_DATA.forEach(business => {
    business.categories.forEach(category => {
      if (!categoryMap[category]) {
        categoryMap[category] = [];
      }
      categoryMap[category].push(business);
    });
  });
  
  return Object.keys(categoryMap);
};
